import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TWarehouseDM from './TWarehouseDM'
import AlternateStockTextMeaning from './AlternateStockTextMeaning'
import AlternateStockText from './AlternateStockText'
import TLinkDM from './TLinkDM'

export default class TEshopStockTextItemDM extends Data {
	public static className = 'TEshopStockTextItemDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	QuantityFrom?: number
	StockTextRID?: number
	RID?: number
	RecordMod?: number
	RecordES?: number
	RecordID?: number
	RecordState?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	PictureCalc?: string
	@Type(() => TWarehouseDM)
	WarehouseId?: TWarehouseDM
	@Type(() => AlternateStockTextMeaning)
	TextMeaningId?: AlternateStockTextMeaning
	@Type(() => AlternateStockText)
	TextId?: AlternateStockText
	@Type(() => TLinkDM)
	LinkChild?: TLinkDM[]
}